// Override Settings
var boostPFSInstantSearchConfig = {
  search: {
    //suggestionMode: 'test',
  }
};

(function() {

  BoostPFS.inject(this); // Add this
  
  // Customize style of Suggestion box
  SearchInput.prototype.customizeInstantSearch = function(suggestionElement, searchElement, searchBoxId) {
    if (jQ(searchBoxId).closest('.search_container').length > 0) {
      this.setSuggestionWidth(searchBoxId, 400);
    }
  };
  
  /* Fix search issue on mobile */
  InstantSearch.prototype.init = function() {
    var inputElements = jQ('input[name="' + Settings.getSettingValue('search.termKey') + '"]:not([data-disable-instant-search])');
    inputElements.each((index, inputElement) => {
  
      if (jQ(inputElement).attr('id') == 'q' && Utils.isMobile()) {
        var id = jQ(inputElement).attr('id');
      } else {
        var id = 'boost-pfs-search-box-' + index;
      }
      var searchBox = new SearchInput(id, jQ(inputElement));
      this.addComponent(searchBox);
    });
    // Build search input for mobile
    if (Utils.isMobile()) {
      // Clear cache when going back from another page
      window.onpageshow = (event) => {
        if (event.persisted) {
          window.location.reload();
        }
      }
      // Build Suggestion mobile on top
      if (Settings.getSettingValue('search.suggestionMobileStyle') !== InstantSearchEnum.Mobile.SuggestionType.STYLE_2) {
        var instantSearchMobile = InstantSearchStyle.instantSearchMobile();
        this.addComponent(instantSearchMobile);
      }
    }
    // Build search input for style3
    if (!Utils.isMobile() && Settings.getSettingValue('search.suggestionStyle') === 'style3' || Settings.getSettingValue('search.suggestionColumn') === '2-overlay-fullwidth') {
      var instantSearchStyle3 = InstantSearchStyle.instantSearchStyle3();
      this.addComponent(instantSearchStyle3);
    }
  };
  
  InstantSearchMobile.prototype.afterCloseInstantSearchMobile = function(isClose) {
    jQ('.close-search').click();
  }
  
  InstantSearchResultItemProduct.prototype.getTemplate = function(tempType) {
    switch (tempType) {
      case InstantSearchResultItemProduct.tempType.IMAGE:
        return `
  					<div class="{{class.searchSuggestion}}-left">
  						<img tabindex="-1" src="{{imageUrl}}" alt="{{escapedTitle}}">
  					</div>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.SKU:
        return `
  					<p class="{{class.searchSuggestion}}-product-sku">Item #: {{sku}}</p>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.VENDOR:
        return `
  					<p class="{{class.searchSuggestion}}-product-vendor">{{vendor}}</p>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.PRICE:
        return `
  					<p class="{{class.searchSuggestion}}-product-price">
  						<span class="{{class.searchSuggestion}}-product-regular-price">{{regularPrice}}</span>
  					</p>
  				`.trim();
      case InstantSearchResultItemProduct.tempType.PRICE_SALE:
        return `
  					<p class="{{class.searchSuggestion}}-product-price">
  						<s>{{compareAtPrice}}</s>&nbsp;
  						<span class="{{class.searchSuggestion}}-product-sale-price">{{regularPrice}}</span>
  					</p>
  				`.trim();
      default:
        return `
  					<li class="{{class.searchSuggestionItem}} {{class.searchSuggestionItem}}-product {{class.searchUiAutocompleteItem}}" aria-label="{{escapedBlockType}}: {{escapedTitle}}" data-id="{{id}}" role="option">
  						<a tabindex="-1" href="{{url}}" {{newTabAttribute}}>
  							{{itemProductImage}}
  							<div class="{{class.searchSuggestion}}-right">
  								<p class="{{class.searchSuggestion}}-product-title">{{title}}</p>
  								{{itemProductSku}}
  								{{itemProductVendor}}
  								{{itemProductPrice}}
  							</div>
  						</a>
  					</li>
  				`.trim();
    }
  }
  
  /**
   * Build the product price and replace with the brackets in raw html template
   */
  InstantSearchResultItemProduct.prototype.compileSuggestionProductPrice = function() {
    // If the multi-currency feature is enabled, update the product price
    this.prepareSuggestionProductPriceData();
    // Check on sale
    var onSale = this.data.compare_at_price_min > this.data.price_min;
    var priceVaries = this.data.price_min != this.data.price_max; // Check a product has many prices
    // Format price
    var price = Utils.formatMoney(this.data.price_min);
    var compareAtPrice = '';
    if (this.data && this.data.compare_at_price_min) {
      compareAtPrice = Utils.formatMoney(this.data.compare_at_price_min);
      if (Settings.getSettingValue('search.removePriceDecimal')) {
        price = Utils.removeDecimal(price);
        compareAtPrice = Utils.removeDecimal(compareAtPrice);
      }
    }
  
    // Build Price
    var result = '';
    if (Settings.getSettingValue('search.showSuggestionProductPrice')) {
      if (onSale && Settings.getSettingValue('search.showSuggestionProductSalePrice')) {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE_SALE);
      } else if (priceVaries) {
        result += '<p class="boost-pfs-search-suggestion-product-price">' +
          '<span class="money price__current--min" data-price-min>' + Utils.formatMoney(this.data.price_min) + '</span>' +
          ' - ' +
          '<span class="money price__current--min" data-price-max>' + Utils.formatMoney(this.data.price_max) + '</span>' +
          '</p>';
  
      } else {
        result = this.getTemplate(InstantSearchResultItemProduct.tempType.PRICE);
      }
    }
    return result
      .replace(/{{regularPrice}}/g, price)
      .replace(/{{compareAtPrice}}/g, compareAtPrice);
  }

  InstantSearchApi.beforeCall = function(searchTerm) {
    /* Change the params before calling api */
    Globals.instantSearchQueryParams.sort = 'best-selling';
  }

  SearchInput.prototype._onSubmit = function(event, redirect) {
    if (isDisabledInstantSearch) return;
    
    if (typeof redirect == 'undefined') {
      redirect = this.isChangePage;
    }
    this.isChangePage = false;
    if (!redirect) {
      // Stop all default submit events
      event.stopImmediatePropagation();
      event.stopPropagation();
      event.preventDefault();
      // Fix case can not get current value from input
      Globals.currentTerm = Utils.stripHtml(this.$element.val());
      if (!Globals.currentTerm && event && event.target) {
        Globals.searchTerm = Utils.stripHtml(event.target.value);
      }
      var redirectUrl = InstantSearchResultRedirect.getSearchRedirectUrl();
      // if API returned results or the suggestionCache has the search term, submit search
      // else: add the data-search-submit attribute to the search input box, wait for the api returns the result,
      // then remove this attribute in the checkForSearchRedirect function
      var query = Utils.unescape(Globals.currentTerm);
      query = query.trim().replace(/\s+/g, ' ');
      var isApiReturnedResult = Globals.suggestionCache.hasOwnProperty(query);
      // Set recent searches
      InstantSearchOnclick.setOnClickRecentSearches(query);
      // If the API returned results, either redirect or perform submit
      if (isApiReturnedResult) {
        if (redirectUrl && !Utils.isBadUrl(redirectUrl)) {
          Utils.setWindowLocation(redirectUrl);
        } else {
          this.isChangePage = true;
          this.$searchForm[0].submit();
        }
      } else if (Globals.currentTerm) {
        // If the API hasn't returned results, set data-search-submit on the search input and wait
        this.$element.data('search-submit', true);
        this.$searchForm[0].submit();
      } else {
        this.isChangePage = true;
        this.$searchForm[0].submit();
      }
    }
  }
  var isDisabledInstantSearch = false;
})();